export default "__VITE_ASSET__BMFWExQ9__"